import {css, Spinner, view} from '@sail/ui/deprecated';
import {ChatRow} from './ChatRow';
import {ChatBubble} from './ChatBubble';

const backgroundToFontColorMapping = {
  neutral100: 'primary',
  neutral600: css.value('white'),
} as const;

export type Props = {
  label?: string;
  position?: 'start' | 'end';
  avatar?: React.ReactNode | null | undefined;
  background?: 'neutral100' | 'neutral600';
};

export const LoadingRow = ({
  label,
  position,
  avatar,
  background = 'neutral100',
}: Props) => {
  return (
    <view.div data-testid="loading-row">
      <ChatRow avatar={avatar} position={position}>
        <ChatBubble background={background}>
          <view.div
            css={{
              font: 'body',
              color: backgroundToFontColorMapping[background],
            }}
          >
            <Spinner css={{verticalAlign: css.value('middle')}} />
            {label ? (
              <view.span css={{marginLeft: css.value('4px')}}>
                {label}
              </view.span>
            ) : null}
          </view.div>
        </ChatBubble>
      </ChatRow>
    </view.div>
  );
};
